import { ConstellationIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import { useState } from 'react';
import { Appointment } from '../../../../data-access/appointments';
import ProposalAISummaryModal from '../modals/ProposalAISummaryModal';

type ProposalAISummaryButtonProps = {
  summaries: Appointment['job']['callSummaries'];
};
const ProposalAISummaryButton: React.FC<ProposalAISummaryButtonProps> = ({
  summaries,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (summaries && summaries.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        startIcon={<ConstellationIcon />}
        color={'softGold'}
        onClick={() => setIsModalOpen(true)}
        fullWidth
      >
        AI call summary
      </Button>

      <ProposalAISummaryModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        summaries={summaries}
      />
    </>
  );
};

export default ProposalAISummaryButton;
